import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, map, switchMap, exhaustMap, catchError, take, delay, first, mergeMap } from 'rxjs/operators';
import { get as _get } from 'lodash';
import { CrmUser, CrmUserRole } from '@app-models/index';
import { APIs } from '@app-settings/index';
import { HttpHeaderService } from '@app-services/http-header.service';
@Injectable()
export class CrmUsersService {
	constructor(
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
	) {
	}
	getoms(first_name, last_name, language_id) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.oms}?first_name_like=${first_name}&last_name_like=${last_name}&language_id_like=${language_id}`, { params: { type: 'A' }, headers: headers });
	}
	getCrmUsers(uuid: string = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers) {
			return of(null);
		} else {
			let api = APIs.crm_users;
			if (uuid)
				api += '/' + uuid;
			return this._httpClient.get(api, { headers: headers });
		}
	}
	//
	// languageCode example: en, es
	//
	getApproverCrmUsers(languageCode: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers) {
			return of(null);
		} else {
			let api = APIs.crm_users;
			if (languageCode)
				api += '/approvers/' + languageCode;
			return this._httpClient.get(api, { headers: headers });
		}
	}
	insertCrmUser(body: CrmUser) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_users, body, { headers: headers });
	}
	updateCrmUser(body: CrmUser, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		const api = `${APIs.crm_users}/${uuid}`;
		return this._httpClient.post(api, body, { headers: headers });
	}
	deleteCrmUser(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		const api = `${APIs.crm_users}/${uuid}`;
		return this._httpClient.delete(api, { headers: headers });
	}
	updateCrmUserImage(body: CrmUser, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		const api = `${APIs.crm_users}/userImage/${uuid}`;
		return this._httpClient.post(api, body, { headers: headers });
	}
	getCrmUserRoles(uuid: string = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.crm_user_roles;
		if (uuid)
			api += '/' + uuid;
		return this._httpClient.get(api, { headers: headers });
	}
	insertCrmUserRole(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_user_roles, body, { headers: headers });
	}
	updateCrmUserRole(body: any = null, role_id: number) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		const api = `${APIs.crm_user_roles}/${role_id}`;
		return this._httpClient.post(api, body, { headers: headers });
	}
	deleteCrmUserRole(role_id: number) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !role_id)
			return of(null);
		const api = `${APIs.crm_user_roles}/${role_id}`;
		return this._httpClient.delete(api, { headers: headers });
	}
}
